import { createEvent, sample } from 'effector'
import type { AnalytixSendMethods } from './index.h'
import { ANALYTIX_EVENT_NAMES, ANALYTIX_EVENT_PARAM_NAMES } from './lib'

export const send = createEvent<{
  name: keyof AnalytixSendMethods
  params: Parameters<AnalytixSendMethods[keyof AnalytixSendMethods]>[0]
  /** Normalized user info snapshot passed to the listener (factory output). */
  general: Record<string, unknown>
}>()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UnionToIntersection<U> = (U extends any ? (x: U) => void : never) extends (
  x: infer I
) => void
  ? I
  : never

type MergedParams = UnionToIntersection<
  Exclude<
    Parameters<AnalytixSendMethods[keyof AnalytixSendMethods]>[0],
    undefined
  >
>

export const sent = createEvent<
  Record<string, unknown> &
    MergedParams & {
      eventName: keyof typeof ANALYTIX_EVENT_PARAM_NAMES
    }
>()

sample({
  clock: send,
  fn({ name, params, general }) {
    const eventName = ANALYTIX_EVENT_NAMES[name]
    return {
      eventName: eventName as keyof typeof ANALYTIX_EVENT_PARAM_NAMES,
      ...general,
      ...(params && typeof params === 'object' ? params : {}),
    }
  },
  target: sent,
})
